export const SET_ONSUBMIT = "SET_ONSUBMIT"
export const SET_ONCANCEL = "SET_ONCANCEL"
